import { ArrowUpRight } from "lucide-react";
import { socialsContent } from "../content";
import { Reveal } from "./Reveal";

export const Socials = () => (
  <section id="redes" className="bg-[#F7F7F5] py-24 md:py-36" data-testid="socials-section">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-[#0B2B46] px-6 py-16 text-white md:px-14 md:py-24">
          <div className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full bg-[#00E5FF]/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-[#1D4E89]/40 blur-3xl" />

          <span className="rounded-full border border-white/20 bg-white/10 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-white/85 backdrop-blur">
            {socialsContent.label}
          </span>
          <h2 className="mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[0.98] tracking-tighter sm:text-5xl lg:text-6xl">
            {socialsContent.headline}
          </h2>

          <div className="mt-14 border-t border-white/15">
            {socialsContent.links.map((link) => (
              <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${link.id}`}
                aria-label={`${link.label} de Lucas Rocha (abre em nova aba)`}
                className="group flex items-center justify-between gap-4 border-b border-white/15 py-6 transition-colors duration-300 hover:bg-white/5 md:py-8"
              >
                <span className="flex flex-wrap items-baseline gap-x-5 gap-y-1 px-2 md:px-4">
                  <span className="font-display text-2xl font-bold tracking-tight md:text-4xl">{link.label}</span>
                  <span className="font-mono text-xs tracking-[0.14em] text-[#00E5FF]">{link.handle}</span>
                </span>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-white/20 text-white/80 transition-colors duration-300 group-hover:border-[#00E5FF] group-hover:bg-[#00E5FF] group-hover:text-[#0B2B46]">
                  <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:rotate-45" />
                </span>
              </a>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
